/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetFilingDetails = require('../../common/services/GetFilingDetails');
var GetEntityExternalUsersByAccessLevel = require('../../common/services/GetEntityExternalUsersByAccessLevel');

var DepManageFilingLawyerView = require('../views/DepManageFilingLawyerView');

module.exports = function(entityId, filingId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetFilingDetails(filingId), GetEntityExternalUsersByAccessLevel({ entityId: entityId, accessLevel: 1 }))
    .done(function(filingDetails, lawyers) {
      NavUtils.navigate('ext/dep/entity/' + entityId + '/filing/' + filingId + '/manage-lawyer');
      Scaffold.content.show(
        new DepManageFilingLawyerView({
          viewMode: 'ext',
          model: new Backbone.Model({
            entityId: entityId,
            filingId: filingId,
            filingDetails: filingDetails,
            lawyers: lawyers
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
